import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseRequestsBusinessUnitPayload } from '../payloads/requestsBusinessUnitPayload';
import { InsightChartFactory, InsightBuilderOptions } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import { groupDataByCategory } from '../utils/dataGrouping';
import { getRequestStatusGroupLegendName } from '../utils/legendLocalizationHelper';
import { foldCompletedIntoApproved } from '../utils/foldCompletedIntoApproved';
import intl from 'react-intl-universal';

export const buildRequestsBusinessUnitInsightFactory = (
  payload: BaseInsightPayload,
  options?: InsightBuilderOptions
): InsightChartFactory => {
  const parsedPayload = parseRequestsBusinessUnitPayload(payload);
  const rawData = options?.isCompletedStatusEnabled
    ? parsedPayload.data.attributes.data
    : foldCompletedIntoApproved(parsedPayload.data.attributes.data, [
        'business_unit_id',
      ]);

  return (props) => {
    // Use the generic data grouping utility
    const { transformedData, uniqueCategories } = groupDataByCategory({
      rawData,
      groupKey: 'business_unit_id',
      displayField: 'business_unit_title',
      categoryField: 'request_status',
      valueField: 'request_count',
    });

    // Create field names, legend names, and stacks
    const xAxisFieldNames = uniqueCategories;
    const legendNames = uniqueCategories.map(getRequestStatusGroupLegendName);
    const stacks = new Array(uniqueCategories.length).fill('requests');

    const chart = new ChartBuilder()
      .setChartType(ChartType.H_BAR_STACK)
      .setProps({
        chartData: transformedData as BarChartData,
        onDrillDown: props.onDrillDown,
        yAxisFieldName: 'business_unit_title',
        xAxisFieldNames,
        legendNames,
        stacks,
        barAxisName: intl.get('INSIGHT.AXIS.NUMBER_OF_REQUESTS'),
        yAxisName: intl.get('INSIGHT.AXIS.BUSINESS_UNITS'),
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
